<i18n>
{
  "en": {
    "flight": {
      "header": "Flight Information",
      "arrivalDateTime": {
        "inputLabel": "Arrival Date and Time"
      },
      "airline": {
        "inputLabel": "Airline",
        "placeholder": "Choose an Airline..."
      },
      "flightNo": {
        "inputLabel": "Flight No",
        "placeholder": "Flight No"
      },
      "verify": {
        "buttonLabel": "Verify Flight",
        "error": "Flight not found. Please double-check your information, and contact Aces if you have further trouble."
      },
      "checkedBags": {
        "checkboxLabel": "Checked baggage"
      },
      "meetAndGreet": {
        "checkboxLabel": "Add Meet and Greet ($15)?",
        "signInputLabel": "Meet and Greet Sign Name"
      },
      "serviceInfo": {
        "standard": "Your driver will track your flight and contact you after you have landed.",
        "meetAndGreet": "Your driver will track your flight and meet you at baggage claim afted you have landed."
      }
    }
  }
}
</i18n>

<template>
  <div class="ui segment" v-bind:class="{ loading: flightInfoInProgress }">
    <h4 class="ui header">{{ $t('flight.header') }}</h4>
    <div class="ui form">

      <div v-if="!flightInfoCompleteValue">
        <div class="field">
          <label>{{ $t('flight.arrivalDateTime.inputLabel') }}</label>
          <div class="ui left icon input">
            <input v-on:change="reset()" type="text" id="date" name="date" placeholder="Pickup Date/Time">
            <i class="calendar alternate outline icon"></i>
          </div>
        </div>
        
        <div class="fields">
          <div class="twelve wide field">
            <label>{{ $t('flight.airline.inputLabel') }}</label>
            <div class="ui search selection dropdown">
              <input v-on:change="selectAirline" type="hidden" name="passengers" v-model="airline">
              <i class ="dropdown icon"></i>
              <div class="default text">{{ $t('flight.airline.placeholder') }}</div>
              <div class="menu">
                <div class="item" data-value="EI">Aer Lingus</div>
                <div class="item" data-value="AR">Aerolineas</div>
                <div class="item" data-value="AM">Aeromexico</div>
                <div class="item" data-value="AC">Air Canada</div>
                <div class="item" data-value="CA">Air China</div>
                <div class="item" data-value="UX">Air Europa</div>
                <div class="item" data-value="AF">Air France</div>
                <div class="item" data-value="MC">Air Mobility Command</div>
                <div class="item" data-value="TN">Air Tahiti</div>
                <div class="item" data-value="AS">Alaska</div>
                <div class="item" data-value="AZ">Alitalia</div>
                <div class="item" data-value="NH">All Nippon Airways</div>
                <div class="item" data-value="AA">American</div>
                <div class="item" data-value="OZ">Asiana</div>
                <div class="item" data-value="OS">Austrian</div>
                <div class="item" data-value="AV">Avianca</div>
                <div class="item" data-value="BA">British Airways</div>
                <div class="item" data-value="SN">Brussels Airlines</div>
                <div class="item" data-value="CX">Cathay Pacific</div>
                <div class="item" data-value="CI">China Air</div>
                <div class="item" data-value="MU">China Eastern</div>
                <div class="item" data-value="CZ">China Southern</div>
                <div class="item" data-value="DE">Condor</div>
                <div class="item" data-value="CM">COPA</div>
                <div class="item" data-value="DL">Delta</div>
                <div class="item" data-value="LY">El Al</div>
                <div class="item" data-value="EK">Emirates</div>
                <div class="item" data-value="ET">Ethiopian</div>
                <div class="item" data-value="EY">Etihad Airways</div>
                <div class="item" data-value="BR">EVA Air</div>
                <div class="item" data-value="FJ">Fiji Airways</div>
                <div class="item" data-value="AY">Finnair</div>
                <div class="item" data-value="F9">Frontier</div>
                <div class="item" data-value="G3">GOL</div>
                <div class="item" data-value="GF">Gulf Air</div>
                <div class="item" data-value="HU">Hainan Airlines</div>
                <div class="item" data-value="HA">Hawaiian</div>
                <div class="item" data-value="IB">Iberia</div>
                <div class="item" data-value="FI">Icelandair</div>
                <div class="item" data-value="JL">Japan Airlines</div>
                <div class="item" data-value="9W">Jet Airways</div>
                <div class="item" data-value="B6">JetBlue</div>
                <div class="item" data-value="KL">KLM</div>
                <div class="item" data-value="KE">Korean Air</div>
                <div class="item" data-value="LA">Latam</div>
                <div class="item" data-value="LO">LOT - Polish Airlines</div>
                <div class="item" data-value="LH">Lufthansa</div>
                <div class="item" data-value="MH">Malaysia </div>
                <div class="item" data-value="NZ">New Zealand</div>
                <div class="item" data-value="DI">Norwegian Air</div>
                <div class="item" data-value="QF">Qantas</div>
                <div class="item" data-value="QR">Qatar</div>
                <div class="item" data-value="RJ">Royal Jordanian</div>
                <div class="item" data-value="SK">SAS</div>
                <div class="item" data-value="SQ">Singapore Airlines Cargo</div>
                <div class="item" data-value="SA">So African Airways</div>
                <div class="item" data-value="WN">Southwest</div>
                <div class="item" data-value="NK">Spirit</div>
                <div class="item" data-value="SY">Sun Country</div>
                <div class="item" data-value="LX">Swiss</div>
                <div class="item" data-value="JJ">TAM Linhas Aereas</div>
                <div class="item" data-value="TP">TAP Portugal</div>
                <div class="item" data-value="TG">Thai Airways</div>
                <div class="item" data-value="TK">Turkish Airlines</div>
                <div class="item" data-value="UA">United</div>
                <div class="item" data-value="VN">Vietnam Airlines</div>
                <div class="item" data-value="VS">Virgin Atlantic Airways</div>
                <div class="item" data-value="VA">Virgin Australia</div>
                <div class="item" data-value="Y4">Volaris</div>
                <div class="item" data-value="WS">WestJet</div>
                <div class="item" data-value="MF">Xiamen</div>
              </div>
            </div>
          </div>
          <div class="four wide field">
              <label>{{ $t('flight.flightNo.inputLabel') }}</label>
              <input v-on:change="reset()" v-model="flightNo" type="text" name="first-name" :placeholder="$t('flight.flightNo.placeholder')">
          </div>
        </div>
        <div>
          <div class="ui field">
            <div class="ui fluid blue submit button" v-bind:class="{ disabled: !readyToVerify() }" v-on:click="verify()">{{ $t('flight.verify.buttonLabel') }}</div>
          </div>
        </div>
      </div>

      <div v-show="flightInfoCompleteValue">
        <div class="field">
          <label>Scheduled Arrival</label>
          <p>Flight {{ airline }} {{ flightNo }}<br/>
          {{ flightInfo.scheduledArrival | moment("dddd, MMMM Do [at] h:mm a") }} from {{ flightInfo.origin }}</p>
        </div>
        <div class="ui checkbox">
          <input type="checkbox" tabindex="0" class="hidden" v-on:change="reactToMeetAndGreet()" v-model="meetAndGreet">
          <label>{{ $t('flight.meetAndGreet.checkboxLabel') }}</label>
        </div>
        <div class="ui checkbox">
          <input type="checkbox" tabindex="0" class="hidden" v-model="checkedBaggage">
          <label>{{ $t('flight.checkedBags.checkboxLabel') }}</label>
        </div>

        <div class="field" v-if="meetAndGreet">
          <label>{{ $t('flight.meetAndGreet.signInputLabel') }}</label>
          <div class="ui input">
            <input type="text" id="meetAndGreetSign" name="meetAndGreetSign" v-model="meetAndGreetSign">
          </div>
        </div>

        <div class="ui message">
          <p>{{ serviceInfoMessage() }}</p>
        </div>
      </div>
      <div v-if="flightInfoError()" class="ui red message">{{ $t('flight.verify.error') }}</div>
      <div v-if="!valid" class="ui red message">
        <p>Pickup time must be at least 4 hours from now to use our online booking. Please email <a href="mailto:reservations@acestowncarservice.com">reservations@acestowncarservice.com</a> and we will work to get you scheduled for service.</p>
      </div>
    </div>
  </div>
</template>

<script>
  import { carkclint } from './mixins/clients/carkclint.js'
  import { textUtil } from './mixins/textUtil.js'
  import Vue from 'vue'
  Vue.use(require('vue-moment'))

  export default {
    name: 'FlightInfo',
    mixins: [carkclint, textUtil],
    data: function () {
      return {
        airline: '',
        flightNo: '',
        flightDate: '',
        flightInfoInProgress: false,
        flightInfoCompleteValue: false,
        flightInfo: {},
        formattedFlightData: {},
        meetAndGreet: false,
        checkedBaggage: false,
        meetAndGreetSign: '',
        valid: true
      }
    },
    methods: {
      verify: function () {
        this.verifyFlight(this.flightDate, this.airline, this.flightNo, 'SEA')
      },
      selectAirline: function (e) {
        this.airline = e.target.value
        this.reset()
      },
      readyToVerify: function () {
        return (this.airline !== '' && this.flightNo !== '' && this.flightDate !== '')
      },
      flightInfoComplete: function () {
        if ('status' in this.flightInfo && this.flightInfo.status === 'Scheduled') {
          this.formattedFlightData.airline = this.airline
          this.formattedFlightData.flightNumber = this.flightNo
          this.formattedFlightData.arrivalAirport = this.flightInfo.destination
          this.formattedFlightData.departureAirport = this.flightInfo.origin
          this.formattedFlightData.checkedBaggage = true

          var momentDateTime = this.momentFromString(this.flightInfo.scheduledArrival)
          this.formattedFlightData.scheduledArrivalDate = this.stringFromMoment(momentDateTime)

          this.valid = false
          var now = this.$moment().add(4, 'hours')
          if (momentDateTime > now) {
            this.valid = true
          }

          this.flightInfoCompleteValue = true

          this.$emit('flightInfoComplete', { complete: this.valid, dateTime: this.momentFromString(this.flightInfo.scheduledArrival).format(), flightInfo: this.formattedFlightData })

          return true
        } else {
          this.flightInfoCompleteValue = false
          return false
        }
      },
      momentFromString: function (str) {
        var m = this.$moment(str, 'YYYYMMDDTHHmmss')
        console.log('moment: ' + m.format() + ' from ' + str)
        return m
      },
      stringFromMoment: function (m) {
        return m.format('YYYY-MM-DDTHH:mm:ss')
      },
      flightInfoError: function () {
        if ('status' in this.flightInfo && this.flightInfo.status !== 'Scheduled') {
          return true
        }
        return false
      },
      serviceInfoMessage: function () {
        if (this.meetAndGreet) {
          return this.$t('flight.serviceInfo.meetAndGreet')
        } else {
          return this.$t('flight.serviceInfo.standard')
        }
      },
      reactToMeetAndGreet: function () {
        this.$emit('meetAndGreetUpdated', this.meetAndGreet)
      },
      reset: function () {
        this.flightInfo = {}
      }
    },
    mounted: function () {
      var v = this

      v.$on('flightConfirmationReceived', function (e) {
        this.flightInfo = e
        this.flightInfoComplete()
      })

      v.$on('flightConfirmationInProgress', function (p) {
        this.flightInfoInProgress = p
      })

      var dateScript = function (currentDate, topDate) {
        $('#date').mobiscroll().calendar({
          onClose: function (t, i) {
            v.flightDate = t
          },
          mode: 'scroller',
          display: 'modal',
          minDate: currentDate,
          maxDate: topDate,
          dateOrder: 'M D dd yy' })
      }

      $(function () {
        var currentDate = new Date()
        var topDate = new Date()
        currentDate.setHours(currentDate.getHours() - 24)
        topDate.setMonth(topDate.getMonth() + 11)
        dateScript(currentDate, topDate)
      })

      $('.dropdown').dropdown()
      $('.checkbox').checkbox()
    }
  }
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/FlightInfo.vue